import { ColumnDef } from "@tanstack/react-table";
import { displayCountOrDash } from "@/core/utils/number";
import { SPIFF_RULE_EVENTS } from "@/spiff-rules/constants";
import { ISpiff } from "@/spiffs/spiffs.d";

interface WithSpiffs {
  spiffs: ISpiff[];
}

const GenericCol = <T extends WithSpiffs>(): ColumnDef<T> => ({
  header: "Generic",
  accessorFn: (row) =>
    row.spiffs.filter(
      (spiff) =>
        spiff.trigger_event === SPIFF_RULE_EVENTS.generic &&
        !spiff.dismissed_at,
    ).length,
  cell: ({ getValue }) => displayCountOrDash(getValue() as number),
});

export default GenericCol;
